import knowledge from './knowledge'

export default knowledge;
